import DateFnsUtils from '@date-io/date-fns';
import { KeyboardTimePicker, MuiPickersUtilsProvider, KeyboardTimePickerProps } from '@material-ui/pickers';

export const TimePickerField = (props: KeyboardTimePickerProps) => (
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <KeyboardTimePicker {...props} />
  </MuiPickersUtilsProvider>
);
